// extracted by mini-css-extract-plugin
export default {"icon":"FactItem_icon_mB9EH"};